let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Eh9P")).then(() => parcelRequire('5V02a'));